import { Menu, MenuItem } from '@mui/material';
import { Handle, Position } from '@xyflow/react'
import { useState } from 'react';
import AddIcon from '@mui/icons-material/Add';
import CheckHandleNodeEvent from '../../../../utils/CheckHandleNodeEvent';

function ChildPathNode({ id, data, onTypeChange, positionAbsoluteX, positionAbsoluteY, selected }) {
    const [anchorEl, setAnchorEl] = useState(null);

    const handleSelectRouteOrPath = (event) => {
        if (anchorEl) {
            setAnchorEl(null);
        } else {
            setAnchorEl(event.currentTarget);
        }
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <div
            className='min-w-[160px] h-6 bg-white border border-gray-300 rounded-sm px-2 justify-center items-center flex flex-col relative cursor-pointer'
            onClick={(e) => handleSelectRouteOrPath(e)}
        >
            <div className='flex justify-center items-center'><AddIcon color="action" sx={{ fontSize: '15px' }} /></div>
            {/* <Handle position={Position.Left} type="target" />
            <Handle position={Position.Right} type="source" /> */}
            <Handle
                id="left-target"
                type="target"
                position={Position.Left}
                style={CheckHandleNodeEvent(data, selected)}
            />
            <Handle
                id="right-source"
                type="source"
                position={Position.Right}
                style={CheckHandleNodeEvent(data, selected)}
            />
            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
            >
                <MenuItem onClick={() => onTypeChange(id, 'path', positionAbsoluteX, positionAbsoluteY)} sx={{ width: '140px' }}>Path</MenuItem>
            </Menu>
        </div>
    )
}

export default ChildPathNode